export { ShowtimeDetailsPanel } from './ShowtimeDetailsPanel'
